"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @since 2019-12-29 09:44
 * @author vivaxy
 */
exports.GAMMA_DIVISION = 1e5;
